import {Country} from '../types/geolocations';
import {Location} from '../types/locations';
import {sortAlpha} from '../utils/sortAlpha';
import {instance} from './index';

export async function getCountries(): Promise<Country[]> {
  return instance()
    .get<Country[]>('/v2/geolocation/countries')
    .then(response => sortAlpha(response.data, 'name'));
}

export async function getCountryById(id: number): Promise<Country | null> {
  return instance()
    .get<Country>(`/v2/geolocation/countries/${id}`)
    .then(response => response.data)
    .catch(() => null);
}

export async function getLocationsByCountry(
  idCountry: number,
  idOrganization?: string,
): Promise<Location[]> {
  return instance()
    .get<Location[]>(`/v2/geolocation/countries/${idCountry}/locations`, {
      params: idOrganization ? {idOrganization} : undefined,
    })
    .then(response => sortAlpha(response.data, 'name'));
}
